import { default as addressDetails } from './addressDetails';
import { default as obfuscation } from './obfuscation';
import { default as details } from './details';
import onCheckoutFirstCoownerLastNameChange from './onCheckoutFirstCoownerLastNameChange';
import onCheckoutFirstCoownerNameChange from './onCheckoutFirstCoownerNameChange';

export const firstCoowner = {
  ...addressDetails,
  ...obfuscation,
  ...details,
  ...onCheckoutFirstCoownerLastNameChange,
  ...onCheckoutFirstCoownerNameChange,
};
